export enum KeywordType {
    NAME, EMAIL, COMPANY_NAME
}

export const KeywordTypeList = [
    {
        type: KeywordType.NAME,
        name: "이름"
    },
    {
        type: KeywordType.EMAIL,
        name: "이메일"
    },
    {
        type: KeywordType.COMPANY_NAME,
        name: "회사명"
    }
];